import cn from 'classnames';
import React from 'react';
import styles from './heading3.module.scss';

export interface SubtitleProps {
  bold?: boolean;
  color?: 'primary' | 'secondary' | 'green' | 'grey';
  children: any;
}

const Subtitle: React.FC<SubtitleProps> = ({
  children,
  color = 'green',
  bold = false
}) => (
  <h3 className={cn(styles.heading3, styles[color], { [styles.bold]: bold })}>
    {children}
  </h3>
);

export default Subtitle;
